<template>
    <!-- <v-app id="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">测试页面</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content>
            <v-container>

            </v-container>
        </v-content>
    </v-app> -->
    <JoinCompany />
</template>

<script>
import JoinCompany from './Biz/Company/JoinCompany'
export default {
  components: {
    JoinCompany
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    goBack: function() {
      var that = this;
      that.$router.back()
    }
  }
}
</script>

<style scoped>
</style>
